import { useState, type ImgHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import logoBottega from "@/assets/logo-bottega.webp";

export function SafeImage({
  src,
  alt,
  className,
  ...rest
}: ImgHTMLAttributes<HTMLImageElement>) {
  const [errored, setErrored] = useState(false);
  const [loaded, setLoaded] = useState(false);
  // Logo placeholder: SOLO dopo errore reale di caricamento.
  if (errored) {
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-brand-cream p-6",
          className,
        )}
        aria-label={typeof alt === "string" ? alt : undefined}
      >
        <img
          src={logoBottega}
          alt=""
          aria-hidden="true"
          className="max-w-[70%] max-h-[70%] object-contain opacity-70 select-none"
        />
      </div>
    );
  }
  // Nessun src ancora: mostra fondo neutro (stesso spazio riservato dal wrapper caller).
  if (!src) {
    return (
      <div
        className={cn("bg-brand-cream-dark", className)}
        aria-label={typeof alt === "string" ? alt : undefined}
      />
    );
  }
  return (
    <img
      {...rest}
      src={src}
      alt={alt}
      onError={() => setErrored(true)}
      onLoad={() => setLoaded(true)}
      loading={rest.loading ?? "lazy"}
      decoding={rest.decoding ?? "async"}
      style={{
        backgroundColor: "hsl(var(--brand-cream, 40 30% 92%))",
        ...(rest.style ?? {}),
      }}
      className={cn(
        className,
        "transition-opacity duration-300",
        loaded ? "opacity-100" : "opacity-0",
      )}
    />
  );
}
